// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".htsModal--z9ZJc .ant-modal-header {\n    padding: 16px;\n}\n", "",{"version":3,"sources":["webpack://./src/apps/consumer/pages/Orders/OrderDetailsPage/components/styles.css"],"names":[],"mappings":"AACI;IACI,aAAa;AACjB","sourcesContent":[".htsModal {\n    & :global(.ant-modal-header) {\n        padding: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"htsModal": "htsModal--z9ZJc"
};
export default ___CSS_LOADER_EXPORT___;
